import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';
import { formatNumber } from '..';

type LabourCostColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
};

export const labourCostColumnConfig = <T extends TableRow>({
  options,
}: LabourCostColumnConfig<T> = {}): TableColumn<T> => ({
  id: 'labourCost',
  label: <Trans i18nKey="labour_cost" />,
  render: (value: number) => (
    <div className="overflow-hidden text-ellipsis">{formatNumber(value)}€</div>
  ),
  acessorKey: 'labourCost',
  sortable: false,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
